// ─────────────────────────────────────────────────────────────────────────────
// Qty Mode helpers — strategy-level mode that governs the WATCHLIST quantity
// column. Config qty_mode is only FIXED_QTY | BY_MARGIN; the column LABEL is
// display-only and additionally depends on segment (no LOT mode in the model):
//   BY_MARGIN                          → "Margin" (field `marginValue`)
//   FIXED_QTY + INDEX / FNO            → "Lot"    (field `qtyValue`)
//   FIXED_QTY + STOCK / ETF (default)  → "Qty"    (field `qtyValue`)
// ─────────────────────────────────────────────────────────────────────────────

// Column header / field label for the mode (segment-aware, display-only).
export function qtyColumnLabel(mode, segment) {
  if (mode === 'BY_MARGIN') return 'Margin';
  const seg = String(segment || '').toUpperCase();
  if (seg === 'INDEX' || seg === 'FNO') return 'Lot';
  return 'Qty';
}

// Watchlist row field that holds the editable value for this mode.
export function qtyRowField(mode) {
  return mode === 'BY_MARGIN' ? 'marginValue' : 'qtyValue';
}

// Value display for the confirmation modal: ₹ amount for BY_MARGIN, plain otherwise.
export function formatQtyWithMode(value, mode) {
  if (value == null || value === '') return '—';
  if (mode === 'BY_MARGIN') {
    const n = Number(value);
    return `₹${Number.isNaN(n) ? value : n.toLocaleString('en-IN')}`;
  }
  return String(value);
}
